/**
 * Информация о полученном баннере
 */
export var EAdFoxBannerOnErrorType;
/**
 * Информация о полученной ошибке
 */

(function (EAdFoxBannerOnErrorType) {
  EAdFoxBannerOnErrorType["ProcessBundleParams"] = "processBundleParams";
  EAdFoxBannerOnErrorType["AdfoxBackend"] = "adfoxBackend";
  EAdFoxBannerOnErrorType["UserScriptError"] = "userScriptError";
  EAdFoxBannerOnErrorType["LoadScriptError"] = "loadScriptError";
})(EAdFoxBannerOnErrorType || (EAdFoxBannerOnErrorType = {}));